import {
  LIST, LIST_DONE, CREATE, CREATE_DONE, UPDATE, UPDATE_DONE, DELETE, DELETE_DONE,
} from './types';

const reducer = (state = {}, action) => {
  const { type, payload, error } = action;
  switch (type) {
  case LIST:
    return { ...state, loading: true };
  case LIST_DONE:
    if (!error) {
      return { ...state, list: payload, loading: false };
    }
    return { ...state, loading: false };
  case CREATE:
    return { ...state, creating: true };
  case CREATE_DONE:
    if (!error) {
      const { clientId } = payload;
      return { ...state, list: { ...state.list, [clientId]: payload }, creating: false };
    }
    return { ...state, creating: false };
  case UPDATE:
    return {
      ...state,
      updating: true,
    };
  case UPDATE_DONE:
    if (!error) {
      const { clientId } = payload;
      return {
        ...state,
        list: {
          ...state.list,
          [clientId]: payload,
        },
        updating: false,
      };
    }
    return { ...state, updating: false };
  case DELETE:
    return {
      ...state,
      deleting: true,
    };
  case DELETE_DONE:
    if (!error) {
      const { [payload.clientId]: _, ...list } = state.list;
      return { ...state, list, deleting: false };
    }
    return {
      ...state,
      deleting: false,
    };
  default:
    return state;
  }
};

export default reducer;
